// 위임 생성 폼 제출 UX 컨트롤러 — 제출 중 버튼 내 스피너 표시 + 제출 버튼 비활성(중복 제출 방지)
// 호출처: app/views/agents/new_delegation.html.erb, app/views/agents/new.html.erb 의 form_with(data-controller=delegation-submit).
// 동작: turbo:submit-start 에 start(), turbo:submit-end 에 end() 가 연결된다.
//       성공 시 서버가 turbo_stream 으로 성공 모달을 #delegation-modal-root 에 append 하므로
//       스피너가 꺼진 뒤 모달이 화면을 덮는다(모달 z-index 가 스피너보다 위).
// WHY(오버레이→버튼 내 스피너): 화면중앙 fixed 오버레이는 긴 폼에서 위치가 어긋나 안 보였다.
//       스피너를 sticky 제출 버튼 안에 두어 스크롤 위치와 무관하게 항상 보이게 한다.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "spinner", "label"]

  // 제출 시작: 버튼 내 스피너 표시 + 버튼 비활성(반투명 처리로 비활성 상태를 시각화)
  start() {
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "inline-block"
    if (this.hasButtonTarget) { this.buttonTarget.disabled = true; this.buttonTarget.style.opacity = "0.7" }
  }

  // 제출 종료(성공/실패 모두): 스피너 숨김 + 버튼 복구. 성공 시 모달이 위를 덮는다.
  end() {
    if (this.hasSpinnerTarget) this.spinnerTarget.style.display = "none"
    if (this.hasButtonTarget) { this.buttonTarget.disabled = false; this.buttonTarget.style.opacity = "" }
  }
}
